import { Environment } from './environment.type';

export const environment: Environment = {
  production: false,
  apiUrl: 'https://backend-staging.tmdigital.ag',
  bffApiUrl: 'https://backend-monitoring-staging.tmdigital.ag/bff',
  e2e: {
    appUrl: 'https://app-staging.tmdigital.ag',
    userEmail: 'saas+e2e@tmdigital.ag',
    userPassword: '5DDJUCLnJkbYP4u',
  },
  mapboxToken: 'pk.eyJ1IjoieWFucHMiLCJhIjoiY20ycDJjeHU1MG44azJrcTh0Z2k4ODJuNyJ9.Pz39eQ56inKFuVg7GmEZlw',
  ampKey: '',
  ampSecret: '',
  tmPanel: 'https://risk-staging.tmdigital.ag',
  loginURL: 'https://login-staging.tmdigital.ag',
  branchName: '{BRANCH_NAME}',
  maintenanceBannerEnabled: false,
  firebase: {
    apiKey: 'AIzaSyCpaqpY0-q9utQbKAXEwGQ48cOOYlMQiJg',
    authDomain: 'barter-prod-80ecb.firebaseapp.com',
    projectId: 'barter-prod',
    storageBucket: 'barter-prod.firebasestorage.app',
    messagingSenderId: '110987119577',
    appId: '1:110987119577:web:712c80b9e9b665cfbe27c8',
  },
};
